export default __webpack_public_path__ + "static/media/S_C_False.84dae198.jpg";